/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-migrations" */ `./list.vue` );

export default {
	path: `migrations`,
	children: [
		{
			path: ``,
			name: `list-run-once-migrations`,
			component: List,
			meta: {
				title: `Run-once Migrations`
			}
		}
	]
};
